import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { saveAppLocale } from 'utils/localStorage';

import { detectAppLocale } from './mappers';

interface LocaleState {
  locale: string;
}

const initialState: LocaleState = {
  locale: detectAppLocale()
};

const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    setLocale(state, action: PayloadAction<string>) {
      state.locale = action.payload;
      saveAppLocale(action.payload);
    }
  }
});

export const { setLocale } = localeSlice.actions;

export default localeSlice.reducer;
